import ClientDetailService from '@/views/ClientDetail/ClientDetailServices';

import {
  APPLY_FILTERS,
  SET_ACTIVE_CONTRACTS,
  SET_CLOSE_CONTRACTS,
  SET_CLIENT_DETAIL,
  SET_CLIENT_NOTES,
  SET_CLIENT_DOC_TYPES,
  SET_CLIENT_DOCS,
  SET_CLIENT_BANK_ACCOUNTS,
  SET_CHECK_CONTRACT_COMPONENT,
  SET_CONTRACTS
} from './types';

export default {
  applyFilter({ commit }, filters) {
    commit(APPLY_FILTERS, filters);
  },

  async getContracts({ commit, state }) {
    const { items } = await ClientDetailService.getContractsByClientId(state.targetingClient.id);
    commit(SET_CONTRACTS, { items });
  },

  async getActiveContractByClientId({ commit, state }, id) {
    const { items, total } = await ClientDetailService.getActiveContractsByClientId(id, state.filters);
    commit(SET_ACTIVE_CONTRACTS, { items, total });
  },

  async getCloseContractByClientId({ commit, state }, id) {
    const { items, total } = await ClientDetailService.getCloseContractsByClientId(id, state.filters);
    commit(SET_CLOSE_CONTRACTS, { items, total });
  },

  async getClientDetail({ commit }, id) {
    const result = await ClientDetailService.getClientDetail(id);
    commit(SET_CLIENT_DETAIL, result);
  },

  async updateClient({ commit }, { id, data }) {
    const result = await ClientDetailService.updateClient(id, data);
    commit(SET_CLIENT_DETAIL, result);
  },

  async getClientNotes({ commit, state }) {
    const result = await ClientDetailService.getClientNotes(state.targetingClient.id);
    commit(SET_CLIENT_NOTES, result);
  },

  async getClientDocTypes({ commit }) {
    const result = await ClientDetailService.getClientDocTypes();
    commit(SET_CLIENT_DOC_TYPES, result);
  },

  async getClientDocs({ commit, state }) {
    const { items } = await ClientDetailService.getClientDocs(state.targetingClient.id);
    commit(SET_CLIENT_DOCS, items);
  },

  async getClientBankAccounts({ commit }, id) {
    const result = await ClientDetailService.getClientBankAccounts(id);
    commit(SET_CLIENT_BANK_ACCOUNTS, result);
  },

  async setCheckContract({ commit }, checkContract) {
    commit(SET_CHECK_CONTRACT_COMPONENT, checkContract);
  }
};
